//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetName",{R_:{printerName:''}},0,0],[[],"GetIdentifier",{R_:{printerId:''}},0,0],[[],"GetStatus",{R_:{printerStatus:''}},0,0],[["isBox","dLength","dWidth","dDiameter","dHeight","dTrayHeight"],"GetDimensions",{},0,0],[[],"GetOrigin",{R_:{origin:''}},0,0]],[]];
SPLM.Mfg.AM.Printer = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.Printer";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;